import React from "react";
import Modal from "../../../../Common/Modal";
import MtiButton from "../../../../Buttons/MtiButton";
import "./RunAutoCalibrationModal.css";

type Props = {
  show: boolean;
  onClicNo: () => void;
  onClickYes: () => void;
};

export default function SlotCorrectionFoundModal({
  show,
  onClicNo,
  onClickYes,
}: Props) {
  return (
    <Modal
      show={show}
      onHide={onClicNo}
      hideOnBackdropClick={false}
      className="auto-calibration-run-modal"
    >
      <Modal.Header
        title={"Slot Correction"}
        hideButtonEnabled={false}
        className="auto-calibration-run-header"
      />
      <Modal.Body className="auto-calibration-run-body">
        <svg
          width="83"
          height="83"
          viewBox="0 0 83 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.5003 76.0837C60.6002 76.0837 76.0837 60.6002 76.0837 41.5003C76.0837 22.4005 60.6002 6.91699 41.5003 6.91699C22.4005 6.91699 6.91699 22.4005 6.91699 41.5003C6.91699 60.6002 22.4005 76.0837 41.5003 76.0837ZM34.5837 13.8337L38.042 48.417H44.9587L48.417 13.8337H34.5837ZM41.5003 69.167C45.3203 69.167 48.417 66.0703 48.417 62.2503C48.417 58.4304 45.3203 55.3337 41.5003 55.3337C37.6804 55.3337 34.5837 58.4304 34.5837 62.2503C34.5837 66.0703 37.6804 69.167 41.5003 69.167Z"
            fill="#F7A246"
          />
        </svg>

        <div className="progress-title">
          <p>There are corrected slot[s] detected on the system</p>
        </div>
        <div className="progress-subtittle">Keep Slot Correction result?</div>
      </Modal.Body>
      <Modal.Footer className="auto-calibration-run-footer">
        <MtiButton
          variant="secondary"
          colorVariant="default"
          size="large"
          onClick={onClicNo}
          style={{
            width: 157,
          }}
        >
          <span>NO</span>
        </MtiButton>
        <MtiButton
          variant="primary"
          colorVariant="default"
          size="large"
          onClick={onClickYes}
          style={{
            width: 157,
          }}
        >
          <span>YES</span>
        </MtiButton>
      </Modal.Footer>
    </Modal>
  );
}
